import React from 'react';

const IconTest = () => {
  const testIcons = [
    { class: 'fas fa-calendar-alt', name: 'Calendar' },
    { class: 'fas fa-clock', name: 'Clock' },
    { class: 'fas fa-map-marker-alt', name: 'Map Marker' },
    { class: 'fas fa-users', name: 'Users' },
    { class: 'fas fa-info-circle', name: 'Info Circle' },
    { class: 'fas fa-gift', name: 'Gift' },
    { class: 'fas fa-check-circle-fill', name: 'Check Circle' },
    { class: 'fas fa-map', name: 'Map' },
    { class: 'fas fa-external-link-alt', name: 'External Link' },
    { class: 'fas fa-images', name: 'Images' },
    { class: 'fas fa-search', name: 'Search' },
    { class: 'fas fa-translate', name: 'Translate' },
    { class: 'fas fa-sync-alt', name: 'Sync' },
    { class: 'fas fa-facebook', name: 'Facebook' },
    { class: 'fas fa-twitter', name: 'Twitter' },
    { class: 'fas fa-instagram', name: 'Instagram' },
    { class: 'fas fa-comment', name: 'Comment' },
    { class: 'fas fa-chevron-left', name: 'Chevron Left' },
    { class: 'fas fa-chevron-right', name: 'Chevron Right' },
    { class: 'fas fa-exclamation-triangle-fill', name: 'Warning' },
    { class: 'fas fa-arrow-clockwise', name: 'Refresh' },
    { class: 'fas fa-arrow-left', name: 'Arrow Left' }
  ];

  return (
    <div style={{ 
      padding: '2rem', 
      fontFamily: 'Noto Sans Thai, sans-serif',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      <h1 style={{ color: '#df2528', marginBottom: '2rem' }}>
        🧪 Font Awesome Icon Test
      </h1>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        {testIcons.map((icon, index) => (
          <div key={index} style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '1rem',
            textAlign: 'center',
            backgroundColor: '#f9f9f9'
          }}>
            <i 
              className={icon.class} 
              style={{ 
                fontSize: '2rem', 
                color: '#df2528',
                marginBottom: '0.5rem',
                display: 'block'
              }}
            ></i>
            <div style={{ fontSize: '0.9rem', color: '#666' }}>
              {icon.name}
            </div>
            <div style={{ fontSize: '0.8rem', color: '#999', marginTop: '0.5rem' }}>
              {icon.class}
            </div>
          </div>
        ))}
      </div>

      <div style={{ 
        backgroundColor: '#e8f4fd', 
        padding: '1rem', 
        borderRadius: '8px',
        border: '1px solid #b3d9ff'
      }}>
        <h3 style={{ color: '#0066cc', marginBottom: '1rem' }}>
          📋 Test Results
        </h3>
        <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
          <li>✅ If you see icons above, Font Awesome is working correctly</li>
          <li>❌ If you see squares or boxes, there's still a font loading issue</li>
          <li>🔧 The CSS fix should ensure icons display properly</li>
        </ul>
      </div>

      <div style={{ 
        marginTop: '2rem',
        padding: '1rem',
        backgroundColor: '#fff3cd',
        borderRadius: '8px',
        border: '1px solid #ffeaa7'
      }}>
        <h4 style={{ color: '#856404', marginBottom: '0.5rem' }}>
          🔧 Applied Fixes:
        </h4>
        <ul style={{ margin: 0, paddingLeft: '1.5rem', fontSize: '0.9rem' }}>
          <li>Added Font Awesome CSS rule to override global font-family</li>
          <li>Moved Font Awesome import to index.js for early loading</li>
          <li>Removed redundant CDN imports from components</li>
          <li>Fixed API base URL to use relative paths</li>
        </ul>
      </div>
    </div>
  );
};

export default IconTest; 